export default __webpack_public_path__ + "static/media/ai-img1.6e33992c.png";